import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconChevronSvg } from "./IconChevronSvg.mjs";
import { root, up, left, right } from "./IconChevron.css.mjs";
const IconChevron = ({
  direction = "down",
  ...props
}) => {
  const { className, ...iconProps } = useIcon(props);
  return /* @__PURE__ */ jsx(
    Box,
    {
      component: IconChevronSvg,
      className: [
        root,
        className,
        {
          [up]: direction === "up",
          [left]: direction === "left",
          [right]: direction === "right"
        }
      ],
      ...iconProps
    }
  );
};
export {
  IconChevron
};
